<template>
  <div id="app">
    <navbar></navbar>
    <router-view/>
  </div>
</template>

<script>
import navbar from './components/narbar'
export default {
  name: 'App',
  components:{
    navbar: navbar
  },
}
</script>

<style lang="sass">

#app 
  font-family: Segoe UI, Microsoft JhengHei, Sans Francisco, PingFang
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale



</style>



// WEBPACK FOOTER //
// src/App.vue